import React from "react";

import { Button } from "reactstrap";
import "./styles.css";

export function BookCard({ item, onRedirect }) {
  const actions = [
    {
      title: "Abrir Livro",
      icon: "book",
      action: () =>
        onRedirect(
          `content/list/0?serie=${item.serie_id}&discipline=${item.discipline_id}`
        )
    },
    ...(item.url
      ? [
          {
            title: "Livro Digital de Atividades",
            icon: "file-text-o",
            action: () => window.open(item.url, "_blank")
          }
        ]
      : [])
  ];

  return (
    <div className="book-card position-relative">
      <div className="bannerOverlay">
        {actions.map(action => (
          <Button
            color="light"
            className="w-100 d-flex align-items-center justify-content-center"
            key={action.title}
            onClick={action.action}
          >
            <i className={`fa fa-${action.icon} mr-1`} />
            <small>{action.title}</small>
          </Button>
        ))}
      </div>
      {item.image ? (
        <img
          src={item.image}
          className="cursor w-100 h-100 p-0 rounded-md shadow-sm"
          style={{ objectFit: "cover" }}
          alt="Book"
        />
      ) : (
        <div className="contentImg w-100 bg-light">
          <i className="contentIcon fa fa-book text-white"></i>
        </div>
      )}
      {item.code && !item.image && (
        <p
          className="w-100 text-center position-absolute"
          style={{
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.7)"
          }}
        >
          {item.code}
        </p>
      )}
    </div>
  );
}
